export default __webpack_public_path__ + "static/media/btn-malvorlagen.6bf26db5.webp";